export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  imageQuery: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'nana-lite-launch',
    title: '娜娜轻量版全新发布：极简设计，极致体验',
    excerpt: '经过团队的精心打磨，娜娜轻量版正式与大家见面。我们以"少即是多"为设计理念，打造了一款体积小、启动快、功能精准的轻量化应用，为追求高效的用户提供全新选择。',
    content: `<p>经过团队的精心打磨，娜娜轻量版正式与大家见面。我们以"少即是多"为设计理念，打造了一款体积小、启动快、功能精准的轻量化应用，为追求高效的用户提供全新选择。</p>
    <h2>为什么选择轻量版？</h2>
    <p>在当今应用日益臃肿的时代，我们注意到许多用户并不需要全部功能。他们渴望一款简洁、快速、不占资源的工具。娜娜轻量版正是为此而生。我们的安装包体积仅为主版本的30%，启动速度提升了200%，同时保留了最核心、最常用的功能模块。</p>
    <h2>核心设计理念</h2>
    <p>我们坚持三个基本原则：第一，功能精确——只保留经过数据验证的高频使用功能；第二，交互极简——每个操作不超过三步即可完成；第三，性能卓越——在任何设备上都能流畅运行。这不是功能的减法，而是体验的加法。</p>
    <h2>安装体验</h2>
    <p>从下载到首次使用，整个过程不超过两分钟。我们优化了安装流程，去除了繁琐的配置步骤，让用户能够开箱即用。同时，轻量版与完整版的数据完全互通，用户可以随时在两版之间无缝切换。</p>
    <h2>未来展望</h2>
    <p>娜娜轻量版将持续迭代，我们会根据用户反馈，在保持轻量的前提下，逐步加入更多智能化功能，让轻盈与强大并行不悖。</p>`,
    category: 'product-updates',
    author: '娜娜团队',
    date: '2026-08-08',
    readTime: '6分钟',
    imageSeq: 'article-launch',
    imageQuery: 'Minimalist%20lightweight%20app%20on%20a%20clean%20white%20desk%20with%20soft%20natural%20lighting%2C%20elegant%20and%20simple%20design%2C%20warm%20cream%20background%2C%20editorial%20product%20photography%20with%20gentle%20shadows',
    tags: ['产品发布', '轻量版', '新版本'],
  },
  {
    slug: 'boost-productivity-with-nana-lite',
    title: '如何用娜娜轻量版提升日常工作效率',
    excerpt: '在日常工作中，工具的响应速度和操作效率直接影响产出。本文分享五个实用技巧，帮助你在娜娜轻量版中建立高效的工作流程，让每一分钟都更有价值。',
    content: `<p>在日常工作中，工具的响应速度和操作效率直接影响产出。本文分享五个实用技巧，帮助你在娜娜轻量版中建立高效的工作流程。</p>
    <h2>技巧一：善用快捷键</h2>
    <p>娜娜轻量版内置了丰富的快捷键体系。掌握"Ctrl+K"快速唤起命令面板，可以让你在不离开键盘的情况下完成绝大部分操作。建议花十分钟熟悉最常用的十个快捷键，长期来看可以节省大量时间。</p>
    <h2>技巧二：自定义工作区</h2>
    <p>每个人的工作习惯不同。娜娜轻量版支持高度自定义的工作区布局，你可以根据自己的需要，将最常用的功能模块固定在首页，不常用的功能折叠收起，打造专属于你的高效空间。</p>
    <h2>技巧三：智能分类管理</h2>
    <p>利用标签和分类系统，将你的内容进行有效组织。娜娜轻量版的智能分类引擎可以根据使用频率和关联度，自动为你推荐最合适的分类方案。</p>
    <h2>技巧四：定时提醒与专注模式</h2>
    <p>开启专注模式后，所有非紧急通知将被静音，让你能够全身心投入当前任务。配合番茄钟定时提醒，科学管理你的工作节奏。</p>
    <h2>技巧五：数据同步与备份</h2>
    <p>开启自动同步功能，确保你的数据在所有设备间无缝流转。娜娜轻量版采用增量同步技术，既保证了数据的实时性，又不消耗过多流量。</p>`,
    category: 'tutorials',
    author: '李明',
    date: '2026-08-05',
    readTime: '8分钟',
    imageSeq: 'article-productivity',
    imageQuery: 'Modern%20workspace%20with%20laptop%20showing%20minimalist%20productivity%20app%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%20with%20notebook%20and%20coffee%2C%20soft%20cream%20and%20wood%20tones',
    tags: ['效率提升', '使用技巧', '工作流程'],
  },
  {
    slug: 'lite-vs-full-comparison',
    title: '轻量版 vs 完整版：如何选择适合你的版本',
    excerpt: '很多用户在娜娜轻量版和完整版之间犹豫不决。本文从功能、性能、适用场景等多个维度进行详细对比，帮助你做出最适合自己的选择。',
    content: `<p>很多用户在娜娜轻量版和完整版之间犹豫不决。本文从多个维度进行详细对比。</p>
    <h2>功能对比</h2>
    <p>完整版包含全部120+功能模块，而轻量版精选了其中使用频率最高的40个核心功能。对于80%的日常使用场景来说，轻量版完全够用。只有在需要高级数据分析、团队协作管理等专业场景时，才需要完整版。</p>
    <h2>性能对比</h2>
    <p>轻量版在启动速度上比完整版快2倍，内存占用降低60%，安装包体积仅为完整版的30%。在配置较低的设备上，这种差异尤为明显。</p>
    <h2>适用场景</h2>
    <p>如果你主要用于个人任务管理、笔记记录、日程安排等基础需求，轻量版是最佳选择。如果需要企业级功能、多团队协作、高级报表等，建议使用完整版。</p>
    <h2>如何切换</h2>
    <p>两版之间可以无缝切换，所有数据自动同步。你甚至可以早上用轻量版快速查看日程，下午切换到完整版进行深度工作。</p>`,
    category: 'product-updates',
    author: '王芳',
    date: '2026-08-03',
    readTime: '5分钟',
    imageSeq: 'article-comparison',
    imageQuery: 'Side%20by%20side%20comparison%20of%20two%20smartphone%20app%20interfaces%2C%20one%20minimalist%20one%20comprehensive%2C%20clean%20white%20background%2C%20soft%20shadow%2C%20modern%20UI%20design%20aesthetic',
    tags: ['版本对比', '选择指南', '功能分析'],
  },
  {
    slug: 'hidden-features',
    title: '5个你不知道的娜娜轻量版隐藏功能',
    excerpt: '即使你已经使用了一段时间，娜娜轻量版中可能仍有一些不易发现但非常实用的功能。本文为你揭秘五个被低估的功能亮点。',
    content: `<p>即使你已经使用了一段时间，娜娜轻量版中可能仍有一些不易发现但非常实用的功能。</p>
    <h2>1. 手势操作</h2>
    <p>在移动端，左右滑动可以快速切换视图，双指捏合可以进入全局预览模式，长按任意项目可以呼出快捷菜单。这些手势操作虽然没有在界面上明确标注，但能极大提升操作效率。</p>
    <h2>2. 离线模式</h2>
    <p>即使在没有网络的情况下，娜娜轻量版依然可以正常使用大部分功能。所有修改会在恢复网络后自动同步，非常适合地铁通勤或出差途中的场景。</p>
    <h2>3. 语音输入</h2>
    <p>长按输入框右侧的麦克风图标，即可启动语音输入。支持普通话和英文，识别准确率超过98%，比打字快三倍。</p>
    <h2>4. 智能归档</h2>
    <p>超过30天未访问的内容会被自动标记，系统会根据内容类型和你的使用习惯，智能建议是归档还是删除，帮你保持工作区的整洁。</p>
    <h2>5. 夜间护眼模式</h2>
    <p>不只是简单的暗色主题——娜娜轻量版的护眼模式会根据环境光线和使用时长，动态调整色温和亮度，最大程度减少眼部疲劳。</p>`,
    category: 'tutorials',
    author: '张伟',
    date: '2026-08-01',
    readTime: '7分钟',
    imageSeq: 'article-hidden-features',
    imageQuery: 'Smartphone%20showing%20hidden%20gesture%20features%20of%20a%20minimalist%20app%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20clean%20modern%20photography%20style',
    tags: ['隐藏功能', '使用技巧', '效率'],
  },
  {
    slug: 'installation-guide',
    title: '娜娜轻量版安装与配置完整指南',
    excerpt: '无论你是新用户还是从完整版迁移的老用户，这份详细的安装与配置指南都能帮你快速上手娜娜轻量版，从下载到个性化设置一步到位。',
    content: `<p>无论你是新用户还是从完整版迁移的老用户，这份详细的安装与配置指南都能帮你快速上手。</p>
    <h2>下载与安装</h2>
    <p>访问官方网站下载页面，选择对应平台的安装包。目前支持 Windows、macOS、iOS 和 Android 四大平台。Windows 用户下载 .exe 文件后双击运行，按照提示完成安装。macOS 用户将 .dmg 文件拖入应用程序文件夹即可。</p>
    <h2>首次启动配置</h2>
    <p>首次打开应用时，系统会引导你完成基础配置：选择语言、登录账号、设置主题偏好。如果你是完整版用户，可以选择"从完整版导入数据"，一键同步所有内容。</p>
    <h2>个性化设置</h2>
    <p>进入设置面板，你可以调整通知偏好、同步频率、隐私选项等。建议开启"智能省电模式"，让应用在后台运行时自动降低资源消耗。</p>
    <h2>常见问题</h2>
    <p>如果遇到安装问题，可以访问帮助中心或加入官方用户社群获取支持。我们的客服团队在工作时间内响应时间不超过30分钟。</p>`,
    category: 'tutorials',
    author: '娜娜团队',
    date: '2026-07-28',
    readTime: '6分钟',
    imageSeq: 'article-installation',
    imageQuery: 'Laptop%20screen%20showing%20app%20installation%20process%20with%20progress%20bar%2C%20clean%20modern%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%20aesthetic',
    tags: ['安装指南', '新手教程', '配置'],
  },
  {
    slug: 'minimalist-workflow',
    title: '极简主义工作流：让娜娜轻量版成为你的效率引擎',
    excerpt: '极简主义不只是一种审美，更是一种工作哲学。本文探讨如何借助娜娜轻量版的极简设计理念，构建一套属于你自己的高效工作系统。',
    content: `<p>极简主义不只是一种审美，更是一种工作哲学。本文探讨如何借助娜娜轻量版构建高效工作系统。</p>
    <h2>极简主义的核心原则</h2>
    <p>极简工作流的核心是"聚焦"。每个时间段只专注于一件事，减少任务切换带来的认知损耗。娜娜轻量版的界面设计遵循这一理念，默认只展示当前最相关的信息。</p>
    <h2>构建你的工作系统</h2>
    <p>我们推荐"三清单法"：每日待办、进行中、已完成。每天开始工作时，从待办清单中挑选不超过三件事移到进行中。这种方法简单但极其有效，娜娜轻量版的任务管理模块天然支持这种工作方式。</p>
    <h2>定期回顾与优化</h2>
    <p>每周花15分钟回顾本周的工作数据，娜娜轻量版会自动生成效率报告，帮助你识别时间花在哪里，哪些环节可以优化。</p>`,
    category: 'efficiency-tips',
    author: '陈静',
    date: '2026-07-25',
    readTime: '5分钟',
    imageSeq: 'article-minimalist-workflow',
    imageQuery: 'Clean%20minimalist%20desk%20with%20a%20notebook%20and%20a%20phone%20displaying%20productivity%20app%2C%20morning%20sunlight%20through%20window%2C%20warm%20cream%20and%20beige%20tones%2C%20zen%20atmosphere',
    tags: ['极简主义', '工作流', '效率方法论'],
  },
  {
    slug: 'industry-trends-lightweight-apps',
    title: '2026年轻量化应用发展趋势解读',
    excerpt: '随着用户对应用体验要求的不断提高，轻量化应用正在成为行业新趋势。本文分析当前市场变化和未来发展方向。',
    content: `<p>随着用户对应用体验要求的不断提高，轻量化应用正在成为行业新趋势。</p>
    <h2>市场数据</h2>
    <p>根据最新行业报告，2026年上半年轻量版应用的下载量同比增长了45%，用户留存率比完整版高出18个百分点。这表明越来越多的用户开始主动选择轻量化的解决方案。</p>
    <h2>用户需求变化</h2>
    <p>现代用户的核心诉求正在从"功能全面"转向"体验优先"。他们更看重应用是否快速响应、是否占用过多存储空间、是否消耗过多电量。轻量化应用恰好满足了这些需求。</p>
    <h2>技术驱动</h2>
    <p>WebAssembly、渐进式Web应用等技术的发展，使轻量版应用能够在不牺牲性能的前提下大幅减小体积。娜娜轻量版正是这些前沿技术的实践者。</p>
    <h2>未来展望</h2>
    <p>预计到2027年，轻量化应用将占据应用市场40%以上的份额。AI技术的融入将使轻量版应用变得更加智能，能够根据用户行为动态加载所需功能。</p>`,
    category: 'industry-news',
    author: '赵磊',
    date: '2026-07-22',
    readTime: '6分钟',
    imageSeq: 'article-industry-trends',
    imageQuery: 'Futuristic%20minimalist%20data%20visualization%20chart%20showing%20upward%20trend%2C%20warm%20cream%20background%20with%20clean%20geometric%20patterns%2C%20modern%20infographic%20style%2C%20soft%20lighting',
    tags: ['行业趋势', '轻量化', '市场分析'],
  },
  {
    slug: 'nana-lite-mobile-guide',
    title: '娜娜轻量版手机端深度体验评测',
    excerpt: '移动端是轻量版发挥优势的主战场。本文从界面设计、操作流畅度、功能完整性等角度，对娜娜轻量版手机端进行全面评测。',
    content: `<p>移动端是轻量版发挥优势的主战场。本文对娜娜轻量版手机端进行全面评测。</p>
    <h2>界面与交互</h2>
    <p>手机端界面采用了底部导航+手势操作的组合方案。单手即可完成大部分操作，拇指热区内的元素都经过精心设计。整体视觉风格延续了桌面版的简约美学，但在移动端做了充分的适配优化。</p>
    <h2>性能表现</h2>
    <p>在千元机上测试，冷启动时间为1.2秒，热启动几乎瞬时完成。内存占用稳定在80MB以内，比同类型应用低了40%以上。连续使用两小时，电量消耗仅为8%。</p>
    <h2>功能完整度</h2>
    <p>手机端涵盖了桌面端90%的核心功能，包括任务管理、笔记、日程、文件管理、数据同步等。唯一暂时缺失的是高级报表功能，但团队表示将在下个版本中补齐。</p>
    <h2>总结</h2>
    <p>娜娜轻量版手机端的表现超出了我们的预期。对于移动办公需求较强的用户来说，这是一个非常值得尝试的选择。</p>`,
    category: 'product-updates',
    author: '刘洋',
    date: '2026-07-20',
    readTime: '7分钟',
    imageSeq: 'article-mobile-review',
    imageQuery: 'Smartphone%20in%20hand%20displaying%20minimalist%20app%20interface%20on%20a%20clean%20cafe%20table%2C%20morning%20light%2C%20warm%20cream%20and%20wood%20tones%2C%20lifestyle%20product%20photography',
    tags: ['手机端', '评测', '用户体验'],
  },
  {
    slug: 'efficiency-methods-comparison',
    title: '主流效率方法论对比：GTD、番茄钟、四象限',
    excerpt: '不同的效率方法论适合不同的人群和工作类型。本文对比三种主流方法论，并说明如何用娜娜轻量版实现每种方法。',
    content: `<p>不同的效率方法论适合不同的人群和工作类型。本文对比三种主流方法论。</p>
    <h2>GTD（Getting Things Done）</h2>
    <p>GTD强调"清空大脑"，将所有待办事项记录在外部系统中。娜娜轻量版的收件箱功能完美契合GTD的第一步。后续的整理、组织、回顾、执行四个步骤也都有对应的功能模块支持。</p>
    <h2>番茄钟工作法</h2>
    <p>25分钟专注+5分钟休息的循环模式。娜娜轻量版内置了可自定义时长的番茄钟，支持白噪音背景和自动记录专注时长。</p>
    <h2>四象限法则</h2>
    <p>将任务按重要和紧急两个维度分成四个象限。你可以在娜娜轻量版中使用标签和优先级系统来实现四象限分类，配合筛选功能快速定位当前应该关注的任务。</p>
    <h2>如何选择？</h2>
    <p>创意工作者适合GTD，需要深度专注的工种适合番茄钟，管理者适合四象限。你也可以混合使用，取长补短。</p>`,
    category: 'efficiency-tips',
    author: '陈静',
    date: '2026-07-18',
    readTime: '8分钟',
    imageSeq: 'article-efficiency-methods',
    imageQuery: 'Three%20productivity%20method%20cards%20laid%20out%20on%20a%20clean%20desk%2C%20GTD%20tomato%20timer%20and%20quadrant%20diagram%2C%20warm%20cream%20background%2C%20minimalist%20flat%20lay%20photography',
    tags: ['效率方法论', 'GTD', '番茄钟', '四象限'],
  },
  {
    slug: 'team-collaboration-lite',
    title: '小团队如何用娜娜轻量版实现高效协作',
    excerpt: '5-20人的小团队是轻量版的重要用户群体。本文介绍如何在不使用繁重协作工具的情况下，用娜娜轻量版完成日常团队协作。',
    content: `<p>5-20人的小团队是轻量版的重要用户群体。本文介绍小团队协作方案。</p>
    <h2>共享工作空间</h2>
    <p>创建一个团队共享空间，所有成员可以看到项目进度、待办事项和文档。娜娜轻量版的权限系统让你可以精确控制每个成员的查看和编辑权限。</p>
    <h2>任务分配与追踪</h2>
    <p>直接在任务卡片上@团队成员，对方会收到通知。任务状态变更时，相关人员自动收到更新。整个流程简洁高效，没有复杂的工作流配置。</p>
    <h2>团队知识库</h2>
    <p>利用笔记功能建立团队知识库，将常见问题、操作规范、项目文档集中管理。支持全文搜索和标签分类。</p>
    <h2>适合什么样的团队？</h2>
    <p>最适合扁平化管理、沟通直接的小团队。如果团队超过30人或有严格的审批流程需求，建议配合完整版使用。</p>`,
    category: 'efficiency-tips',
    author: '王芳',
    date: '2026-07-15',
    readTime: '5分钟',
    imageSeq: 'article-team-collab',
    imageQuery: 'Small%20team%20of%20three%20people%20collaborating%20around%20a%20laptop%20in%20a%20bright%20modern%20office%2C%20warm%20neutral%20tones%2C%20natural%20light%2C%20genuine%20interaction',
    tags: ['团队协作', '小团队', '共享空间'],
  },
  {
    slug: 'security-privacy-nana-lite',
    title: '娜娜轻量版数据安全与隐私保护详解',
    excerpt: '数据安全是用户最关心的问题之一。本文详细介绍娜娜轻量版在数据加密、隐私保护和合规方面的技术方案与承诺。',
    content: `<p>数据安全是用户最关心的问题之一。本文详细介绍娜娜轻量版的安全方案。</p>
    <h2>端到端加密</h2>
    <p>所有同步数据均采用AES-256端到端加密，即使是开发团队也无法查看你的私人内容。加密密钥仅存储在用户设备上。</p>
    <h2>隐私保护承诺</h2>
    <p>娜娜轻量版不收集任何非必要的用户数据。我们公开数据收集清单，用户可以在设置中逐一查看和关闭每个数据收集项。</p>
    <h2>合规认证</h2>
    <p>已通过 ISO 27001 信息安全管理体系认证，符合 GDPR 和《个人信息保护法》的要求。定期接受第三方安全审计。</p>
    <h2>用户可控</h2>
    <p>你可以随时导出全部数据，也可以永久删除云端存储的所有内容。数据的所有权和控制权始终在用户手中。</p>`,
    category: 'product-updates',
    author: '娜娜团队',
    date: '2026-07-12',
    readTime: '5分钟',
    imageSeq: 'article-security',
    imageQuery: 'Abstract%20digital%20security%20concept%20with%20lock%20icon%20and%20shield%2C%20warm%20cream%20background%20with%20subtle%20geometric%20patterns%2C%20minimalist%20tech%20illustration%20style',
    tags: ['数据安全', '隐私保护', '加密'],
  },
  {
    slug: 'user-story-freelancer',
    title: '用户故事：自由职业者小林的轻量版使用心得',
    excerpt: '自由职业设计师小林分享他使用娜娜轻量版三个月以来的真实体验，以及这款工具如何改变了他的工作方式。',
    content: `<p>自由职业设计师小林分享他使用娜娜轻量版三个月以来的真实体验。</p>
    <h2>从工具焦虑到轻装上阵</h2>
    <p>"以前我同时使用五六款工具，每天在各种应用之间切换，花在工具管理上的时间比实际工作还多。"小林回忆道。接触娜娜轻量版后，他将所有日常管理整合到了一个应用中。</p>
    <h2>真实的效率提升</h2>
    <p>小林告诉我们，使用轻量版后，他的日均有效工作时间从4.5小时提升到了6小时。"不是因为工作时间变长了，而是切换和等待的时间大大减少了。"</p>
    <h2>最喜欢的三个功能</h2>
    <p>小林最常用的功能是：快捷命令面板（"手不用离开键盘"）、自动分类（"省去了整理的时间"）、专注模式（"终于可以专心画图了"）。</p>
    <h2>对小团队的建议</h2>
    <p>"如果你和我的情况类似——一个人或小团队，追求效率，不喜欢复杂的工具——娜娜轻量版值得认真尝试。"</p>`,
    category: 'industry-news',
    author: '编辑部',
    date: '2026-07-10',
    readTime: '5分钟',
    imageSeq: 'article-user-story',
    imageQuery: 'Freelancer%20working%20happily%20in%20a%20cozy%20home%20office%20with%20laptop%20and%20warm%20lighting%2C%20plants%20on%20desk%2C%20relaxed%20authentic%20atmosphere%2C%20cream%20and%20wood%20interior',
    tags: ['用户故事', '自由职业', '效率提升'],
  },
];

export const getArticlesByCategory = (category: string): Article[] => {
  if (category === 'all') return articles;
  return articles.filter((a) => a.category === category);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};